import Loadable from "../../react-loadable";
import WeaAssociativeSearchMult from "../base/wea-associative-search-mult";
import WeaAssociativeSearch from "../base/wea-associative-search";
import { getKeys } from "../wea-browser-test/components/WeaBrowserTree";
import * as util from "../wea-browser-test/util";

import Main from "../wea-browser-test/index";
// const Main = Loadable({
//   // loader: () => import("./Browser"),
//   loader: () => import("../wea-browser-test/index"),
//   loading: () => null,
//   render: (obj, props, ref) => {
//     if (obj) {
//       return React.createElement(obj && obj.__esModule ? obj.default : obj, {
//         ...props,
//         ref
//       });
//     }
//     return null;
//   }
// });

Main.getKeys = getKeys;
Main.WeaAssociativeSearchMult = WeaAssociativeSearchMult;
Main.WeaAssociativeSearch = WeaAssociativeSearch;
Main.urlOfIframeInDialogCallBack = {};
Main.browserUtil = util;
export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser/index.js